import * as actionTypes from './actionTypes';

export const setCommissionToUpdate=(commission)=>dispatch=>{
    dispatch({
        type:actionTypes.SET_COMMISSION_TO_UPDATE,
        payload:commission
    })
}